/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SystemExchangeRateRespVo
 */
export interface SystemExchangeRateRespVo {
    /**
     * 主键 ID
     * @type {number}
     * @memberof SystemExchangeRateRespVo
     */
    id?: number;
    /**
     * 汇率类型：1-USD汇率，2-电汇(TT)汇率
     * @type {number}
     * @memberof SystemExchangeRateRespVo
     */
    rateType?: number;
    /**
     * 汇率类型名称（按当前语言）
     * @type {string}
     * @memberof SystemExchangeRateRespVo
     */
    rateTypeName?: string;
    /**
     * 汇率值
     * @type {number}
     * @memberof SystemExchangeRateRespVo
     */
    rateValue?: number;
    /**
     * 适用期间-开始日期
     * @type {string}
     * @memberof SystemExchangeRateRespVo
     */
    startDate?: string;
    /**
     * 适用期间-结束日期
     * @type {string}
     * @memberof SystemExchangeRateRespVo
     */
    endDate?: string;
    /**
     * 是否可用 0 不可用，1 可用（当前生效行）
     * @type {number}
     * @memberof SystemExchangeRateRespVo
     */
    enable?: number;
    /**
     * 创建时间
     * @type {string}
     * @memberof SystemExchangeRateRespVo
     */
    createTime?: string;
    /**
     * 修改时间
     * @type {string}
     * @memberof SystemExchangeRateRespVo
     */
    updateTime?: string;
}

/**
 * Check if a given object implements the SystemExchangeRateRespVo interface.
 */
export function instanceOfSystemExchangeRateRespVo(value: object): value is SystemExchangeRateRespVo {
    return true;
}

export function SystemExchangeRateRespVoFromJSON(json: any): SystemExchangeRateRespVo {
    return SystemExchangeRateRespVoFromJSONTyped(json, false);
}

export function SystemExchangeRateRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SystemExchangeRateRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'rateType': json['rateType'] == null ? undefined : json['rateType'],
        'rateTypeName': json['rateTypeName'] == null ? undefined : json['rateTypeName'],
        'rateValue': json['rateValue'] == null ? undefined : json['rateValue'],
        'startDate': json['startDate'] == null ? undefined : json['startDate'],
        'endDate': json['endDate'] == null ? undefined : json['endDate'],
        'enable': json['enable'] == null ? undefined : json['enable'],
        'createTime': json['createTime'] == null ? undefined : json['createTime'],
        'updateTime': json['updateTime'] == null ? undefined : json['updateTime'],
    };
}

export function SystemExchangeRateRespVoToJSON(json: any): SystemExchangeRateRespVo {
    return SystemExchangeRateRespVoToJSONTyped(json, false);
}

export function SystemExchangeRateRespVoToJSONTyped(value?: SystemExchangeRateRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'rateType': value['rateType'],
        'rateTypeName': value['rateTypeName'],
        'rateValue': value['rateValue'],
        'startDate': value['startDate'],
        'endDate': value['endDate'],
        'enable': value['enable'],
        'createTime': value['createTime'],
        'updateTime': value['updateTime'],
    };
}

